module.exports = __webpack_public_path__ + "img/gather.92e78ac4.jpg";